// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2VbFH","col":"styles_col__2h5Zc"};